var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3323_145834)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3323_145834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0807 9.03034C18.7565 5.59471 12.466 6.315 9.03037 10.6392C5.59474 14.9633 6.31503 21.2539 10.6392 24.6895C14.9633 28.1251 21.2539 27.4048 24.6895 23.0807C28.1251 18.7565 27.4048 12.466 23.0807 9.03034Z",
    fill: "#4E5864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9502 24.298C6.84227 21.0342 6.158 15.0581 9.42184 10.9502C12.6857 6.84225 18.6617 6.15797 22.7697 9.42182C26.8776 12.6857 27.5619 18.6617 24.298 22.7696C21.0342 26.8776 15.0582 27.5619 10.9502 24.298Z",
    stroke: "#3B424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.3313 21.3042L22.8953 16.5866L22.7907 16.0253L18.5791 14.6993L16.3354 10.8964L15.765 10.9214L13.3313 21.3042Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3323_145834",
    x: 5.35938,
    y: 5.85946,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3323_145834"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3323_145834",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3323_145834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18.791 33.7208) rotate(-141.532)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarLocation);
export default __webpack_public_path__ + "static/media/4bd9633957cca89847e3a996591be023c49e343ff0.svg";
export { ForwardRef as ReactComponent };